/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProductSelectionProductViewModel } from './ProductSelectionProductViewModel';
import {
    ProductSelectionProductViewModelFromJSON,
    ProductSelectionProductViewModelFromJSONTyped,
    ProductSelectionProductViewModelToJSON,
} from './ProductSelectionProductViewModel';

/**
 * 
 * @export
 * @interface ProductSelectionScenarioViewModel
 */
export interface ProductSelectionScenarioViewModel {
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionScenarioViewModel
     */
    scenarioId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductSelectionScenarioViewModel
     */
    optionName?: string;
    /**
     * 
     * @type {Array<ProductSelectionProductViewModel>}
     * @memberof ProductSelectionScenarioViewModel
     */
    products: Array<ProductSelectionProductViewModel>;
}

/**
 * Check if a given object implements the ProductSelectionScenarioViewModel interface.
 */
export function instanceOfProductSelectionScenarioViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "products" in value;

    return isInstance;
}

export function ProductSelectionScenarioViewModelFromJSON(json: any): ProductSelectionScenarioViewModel {
    return ProductSelectionScenarioViewModelFromJSONTyped(json, false);
}

export function ProductSelectionScenarioViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductSelectionScenarioViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'scenarioId': !exists(json, 'ScenarioId') ? undefined : json['ScenarioId'],
        'optionName': !exists(json, 'OptionName') ? undefined : json['OptionName'],
        'products': ((json['Products'] as Array<any>).map(ProductSelectionProductViewModelFromJSON)),
    };
}

export function ProductSelectionScenarioViewModelToJSON(value?: ProductSelectionScenarioViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ScenarioId': value.scenarioId,
        'OptionName': value.optionName,
        'Products': ((value.products as Array<any>).map(ProductSelectionProductViewModelToJSON)),
    };
}

